import { Eye } from "@phosphor-icons/react";

import { MobileHeading } from "features/layout/components";

import Loader from "common/components/Loader";
import { Button } from "common/components/ui/Button";
import useWorkspaceToken from "common/datahooks/useWorkspaceToken";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useAgencySettings from "../../datahooks/useAgencySettings";
import useWhitelabelPreviewUrl from "../../hooks/useWhitelabelPreviewUrl";
import SettingsScrollContent from "../SettingsScrollContent";
import CreateCustomization from "./CreateCustomization";
import Domains from "./Domains";
import Email from "./Email";
import Extension from "./Extension";
import GTM from "./GTM";
import Logo from "./Logo";
import AgencyName from "./Name";
import PrimaryColor from "./PrimaryColor";

import type { JSX } from "react";

export default function Whitelabel() {
  const isDesktop = useTwBreakpoint("lg");
  const { agencySettings, isLoadingAgencySettings } = useAgencySettings();
  const { workspaceToken } = useWorkspaceToken();
  const { whitelabelPreviewUrl, refreshWhitelabelPreviewUrl } =
    useWhitelabelPreviewUrl(
      agencySettings
        ? `${agencySettings.slug}.${import.meta.env.VITE_WHITE_LABEL_DOMAIN}`
        : "",
    );

  let content = <CreateCustomization />;
  let actionComponent: JSX.Element;

  if (isLoadingAgencySettings) {
    content = <Loader />;
  } else if (agencySettings) {
    actionComponent = (
      <>
        <Button
          variant="outline-black"
          leftIcon={<Eye />}
          asChild
          size={isDesktop ? "sm" : "md"}
        >
          <a
            target="_blank"
            href={whitelabelPreviewUrl}
            rel="noreferrer"
            onClick={refreshWhitelabelPreviewUrl}
          >
            Preview white label
          </a>
        </Button>
        <Button
          variant="outline-black"
          leftIcon={<Eye />}
          size={isDesktop ? "sm" : "md"}
          asChild
          className="max-lg:ml-auto"
        >
          <a
            target="_blank"
            href={`${import.meta.env.VITE_WHITE_LABEL_URL}${workspaceToken ? `#${workspaceToken}` : ""}`}
            rel="noreferrer"
          >
            Preview login
          </a>
        </Button>
      </>
    );
    content = (
      <>
        <MobileHeading actionComponent={actionComponent} />
        <div>
          <AgencyName />
          <PrimaryColor />
          <Logo />
          <Domains />
          <GTM />
          <Extension />
          <Email />
        </div>
      </>
    );
  }

  return (
    <SettingsScrollContent desktopActionComponent={actionComponent}>
      {content}
    </SettingsScrollContent>
  );
}
